import {DTicketController} from "./dticket.controller";
import {DTicketCheckoutController} from "./checkout/dticket_checkout.controller";

angular
  .module( 'VSPApp' )
  .controller( 'DTicketController', DTicketController )
  .controller( 'DTicketCheckoutController', DTicketCheckoutController );
